import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { HelperService } from '../../../services/helperService';
import { GetCompaniesService } from 'src/services/incadea/incadea-services/getCompanies.service';
import { Observable, map, tap, finalize, catchError, throwError, of, EMPTY,} from 'rxjs';
import { Location, ResponseCompanies } from 'src/services/incadea/incadea-interfaces/responses/ResponseCompanies.interface';

import { MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';

import { RespDeptMakes } from 'src/services/incadea/incadea-interfaces/responses/ResponseDeptMakes.interface';
import { ResponseServices } from 'src/services/incadea/incadea-interfaces/responses/ResponseServices.interface';
import { GetDepartmentsService } from '../../../services/incadea/incadea-services/getDepartments.service';
import { GetMakesService } from '../../../services/incadea/incadea-services/getMakes.service';
import { ScheduleLegend } from 'src/models/scheduleLegend';
import { GetServicesService } from '../../../services/incadea/incadea-services/getServices.service';
import { ResponseResources } from 'src/services/incadea/incadea-interfaces/responses/ResponseResources.interface';
import { GetResourcesService } from 'src/services/incadea/incadea-services/getResources.service';
import { ResponseTimeSlots } from 'src/services/incadea/incadea-interfaces/responses/ResponseTimeSlots.interface';
import { GetTimeSlotsService } from 'src/services/incadea/incadea-services/getTimeSlots.service';
import { FindClientInfoDialog } from './I-dialogs/findClientInfo/find-client-info.dialog';

import { IncadeaBookingService } from 'src/services/api-services/IncadeaBooking.service';

import { IncadeaAppointment, IBAppointmentGET } from 'src/services/api-services/api-interfaces/IBAppointmentGET.interface';

import { HoveredIncadea } from 'src/services/incadea/incadea-interfaces/HoveredData.interface';

import { ICancelAppointmentDialog } from './I-dialogs/cancelAppointment/i-cancel-appointment.dialog';
import { RescheduleDialog } from './I-dialogs/reschedule/reschedule.dialog';
import { AppointmentPartial } from 'src/services/incadea/incadea-interfaces/AppointmentPartial.interface';
import { TranslateService } from '@ngx-translate/core';

import { timeSlotWorkshops } from 'src/services/api-services/api-interfaces/IBWorkshopsTimeSlots.interface';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction';
import allLocales from '@fullcalendar/core/locales-all';
import { IPopoverReschedulingComponent } from './I-dialogs/i-popover-rescheduling/i-popover-rescheduling.component';
@Component({
    selector: 'app-i-scheduling',
    templateUrl: './i-scheduling.component.html',
    styleUrls: ['../../scheduling/scheduling.component.sass'], encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ISchedulingComponent implements OnInit {

token$?: Observable<string>

workshopSlots: timeSlotWorkshops[] =[]
companies$= new Observable<ResponseCompanies[]>();
departments$= new Observable<RespDeptMakes[]>();
makes$= new Observable<RespDeptMakes[]>();
services$ = new Observable< ResponseServices[]>()
resources$= new Observable<ResponseResources[]>()
appointments$= new Observable<IBAppointmentGET>()
dateRange?:any
timeSlots:ResponseTimeSlots[]| timeSlotWorkshops[] =[{}as ResponseTimeSlots]
dayViewTitle = 'Day'
weekViewTitle = 'Week'
monthViewTitle = 'Month'
todayViewTitle = 'Today'
locations?:Location[]= []
selectedLocation?:Location
selectedCompany: ResponseCompanies = { } as ResponseCompanies
selectedDepartment?: RespDeptMakes
selectedMake?: RespDeptMakes
selectedService? : ResponseServices
selectedAdvisor?:ResponseResources
selectedResource?:ResponseResources
tokenString: string =''
searchedElement = '';
plateNumber=''
isSearchingSchedules: boolean = false;
slotDuration= 15
selectedViewIndex=1
displayDate= new Date()
dateInitial: any = new Date();
isLoading= false
isLoadingFilter = false
isSearchedByPlate= false
displayDefaultLegends: boolean = true; // isScheduler Disabled style
startTime:string ='06:00'
endTime: string = "19:00"
schedulerEvents: any[]=[{
  groupId: 'testGroupId',
  start: '2014-11-10T10:00:00',
  end: '2014-11-10T16:00:00',
  display: 'inverse-background'
}]
defaultLegends: ScheduleLegend[] = [
  {
    label: "Available",
    legendConfig: {
      order: 1,
      forecolor: '#FFFFFF',
      backcolor: '#F2F2F2',
      class: 'legend-available',
    },
  },
  {
    label: "NotAvailable",
    legendConfig: {
      order: 2,
      forecolor: '#f5f5f5',
      backcolor: '#D9D9D9',
      class: 'legend-not-available',
    },
  },

];
legends= [...this.defaultLegends]

legendsWithEvent:ScheduleLegend[]=[...this.defaultLegends,
  {
    label: "Event",
    legendConfig: {
      order: 3,
      forecolor: 'var(--brand-primary-color)',
      backcolor: 'var(--brand-primary-color)',
      class: '',
    },
  }

]
// legendsWithShowNoShow:ScheduleLegend[]=[...this.legendsWithEvent, {
//   label: "Show",
//   legendConfig: {
//     order: 4,
//     forecolor: 'var(--brand-complementary-green)',
//     backcolor: 'var(--brand-complementary-green)',
//     class: '',
//   },
// },
// {
//   label: "no Show",
//   legendConfig: {
//     order: 5,
//     forecolor: 'var(--brand-complementary-red)',
//     backcolor: 'var(--brand-complementary-red)',
//     class: '',
//   },
// }]
hoveredData:string=''
plateNumberSearch: string = '';
parsedHovered: HoveredIncadea ={} as HoveredIncadea


calendarOptions: CalendarOptions = {
  initialView: 'timeGridWeek',
  plugins: [timeGridPlugin,dayGridPlugin, interactionPlugin],
  headerToolbar: {
    left: 'today prev,next',
    center:'title',
    right: 'timeGridWeek,timeGridDay'
  },
  dateClick: (arg) => this.openDialog(arg),
  allDaySlot:false,
  locales:  allLocales,
  locale: this.helperService.user.language.split('-')[0],
  slotDuration: `00:${this.slotDuration}:00 `,slotLabelInterval: this.slotDuration, eventTimeFormat: {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    meridiem: true
  },
  initialDate: this.dateInitial,
  datesSet: (arg)=>{

    if(this.dateRange === undefined){this.dateRange= arg
    }
    if (this.selectedResource?.Id && !this.isSearchedByPlate &&  arg.startStr !== this.dateRange.startStr ) {
      this.dateRange= arg

      this.onResourceChange()
    }
    },
  eventClick: (info) => this.onAppointmentClick(info),
  slotLabelFormat:{
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    // meridiem: 'short'
  },
  slotMaxTime:"20:00:00",
  slotMinTime:"05:00:00",
  events:this.schedulerEvents,
  validRange: {
    start: new Date(new Date().getFullYear(), 0, 1),
    end: new Date(new Date().getFullYear()+1, 1, 31)
  }
};
  constructor(public helperService: HelperService,
    public getCompaniesService$:GetCompaniesService,
    public getDepartmentsService: GetDepartmentsService,
    public getMakesService: GetMakesService,
    public getServicesService:GetServicesService,
    public getResourcesServices: GetResourcesService,
    public getTimeSlots:GetTimeSlotsService,
    public incadeaBookingService: IncadeaBookingService,
    public dialog: MatDialog,

    private translate: TranslateService
    )

     {
     }
  ngOnInit(): void {
   this.token$= this.helperService.token.pipe(tap({
    next: (token:string)=>{this.companies$= this.getCompaniesService$.getCompanies(token,this.helperService.user.incadeaBackendCode!)
    this.tokenString=token},
   }));
   const module =this.helperService.modules.filter((module)=>module.label==='Scheduling')[0]
   this.helperService.icon = "calendar_month"
   this.helperService.TitlePage = module.label
  }



  getLocationsDepartmentsAndMakes = (Companies: ResponseCompanies[], selectedCompany: ResponseCompanies)=>{
    this.isSearchedByPlate=false
    this.displayDefaultLegends = true;
    this.onClearPlate()
    this.selectedLocation= undefined
    this.selectedDepartment = undefined
    this.selectedMake = undefined
    this.selectedService = undefined
    this.selectedResource = undefined
    this.searchedElement = 'Location'
    this.isLoadingFilter = true
    this.locations=Companies.find((company: ResponseCompanies)=>company.Id===selectedCompany.Id)?.Locations;
    this.departments$=this.getDepartmentsService.getDepartments(this.tokenString,selectedCompany.Id,this.helperService.user.incadeaBackendCode!).pipe(finalize(()=>
      this.makes$= this.getMakesService.getMakes(this.tokenString,selectedCompany.Id,this.helperService.user.incadeaBackendCode!).pipe(tap({
        complete: () => this.isLoadingFilter = false
      }))
    ))

  }
  onLocationChange(){
    this.isSearchedByPlate=false
    this.displayDefaultLegends = true;
    this.onClearPlate()
    this.selectedDepartment = undefined
    this.selectedMake = undefined
    this.selectedService = undefined
    this.selectedResource = undefined
    this.searchedElement = 'Make'
    //


  }
  onDepartmentChange(event:RespDeptMakes){
    this.isSearchedByPlate=false
    this.displayDefaultLegends = true;
    this.onClearPlate()
    this.selectedMake = undefined
    this.selectedService = undefined
    this.selectedResource = undefined
    this.isLoadingFilter = true
    this.resources$=  this.getResourcesServices.getResources(this.tokenString, this.selectedCompany.Id, this.selectedLocation!.Id,this.helperService.user.incadeaBackendCode!,event.Code)
  .pipe(
       map((resources) =>
        resources.filter(resource =>
           resource.Type === 'ServiceAdvisor')),
           tap({
            complete: () => this.isLoadingFilter = false
          })
      )
   const workshopService= this.incadeaBookingService.getTimeSlotsScheduler(this.selectedCompany.Id, this.selectedLocation!.Id, event.Code).subscribe({
      next: (slots)=>{
        this.workshopSlots= slots
        // console.log(this.workshopSlots);

   if (this.workshopSlots.length > 0) {
    const { startTime, endTime } = slots.reduce((acc, element) => {
      const fromTime = new Date(element.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      const toTime = new Date(element.end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

      if (fromTime <= acc.startTime) {
        acc.startTime = fromTime;
      }

      if (toTime >= acc.endTime) {
        acc.endTime = toTime;
      }

      return acc;
     }, {
      startTime: '23:59', endTime: '00:00'
    }
    );

    // this.startTime = startTime;
    // this.endTime = endTime;
   }
       else {
        // this.startTime  ='06:00'
        // this.endTime  = "18:00"
       }

      },
      complete: ()=>{
        workshopService.unsubscribe()
      },

      error: (error) => {
        // Manejo de error 401
        if (error.status === 401) {
          this.helperService.logoutToken();
        }
      }
    })
  }
  onMakeChange(){
    this.isSearchedByPlate=false
    this.onClearPlate()
    this.selectedService = undefined
    this.selectedResource = undefined
    this.displayDefaultLegends = true;
    this.searchedElement = 'Service'
    this.isLoadingFilter = true
    this.services$= this.getServicesService.getServices(
      this.tokenString,this.selectedCompany.Id, this.selectedLocation!.Id, this.selectedDepartment!.Code, this.selectedMake!.Code,this.helperService.user.incadeaBackendCode!)
      .pipe(
        map((service)=>
      service.filter(service =>
          service.Department === this.selectedDepartment!.Code),
    ),tap({
      complete: () => this.isLoadingFilter = false
    })
    )
  }
  onServiceChange(){
    this.isSearchedByPlate=false
    this.selectedResource = undefined
    this.onClearPlate()
  }
  onResourceChange(){

    this.onClearPlate()
    this.isSearchedByPlate = false
    this.isLoading = true
    // const {start, end}=this.dateRange!.dateRange
    const start = this.dateRange.start
    const end = this.dateRange.end
    if (!this.isSearchedByPlate) {
      this.getTimeSlots.getTimeSlots(
        this.tokenString,
        this.selectedCompany.Id,
        this.selectedLocation!.Id,
        start.toISOString(),
        end.toISOString(),
        [this.selectedResource!.Id],
        [{Id:this.selectedService!.Id}],this.helperService.user.incadeaBackendCode!)

        .subscribe({
          next:(availableTime)=>{

            if (availableTime.length>0) {


              // assigns max and min for calendar shown slots
              const { startTime, endTime } = availableTime.reduce((acc, element) => {
                const fromTime = new Date(element.From).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                const toTime = new Date(element.To).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                if (fromTime < acc.startTime) {
                  acc.startTime = fromTime;
                }

                if (toTime > acc.endTime) {
                  acc.endTime = toTime;
                }

                return acc;
              }, { startTime: '23:59', endTime: '00:00' });

              // this.startTime = startTime;
              // this.endTime = endTime;


              this.timeSlots= availableTime
              let test : any = this.timeSlots
              test.map((event) => {
                event.groupId = 'testGroupId'
                event.start = event.From
                event.end = event.To
                event.display = 'inverse-background'
              })


              this.schedulerEvents = test
              this.displayDefaultLegends = false;
               const diferentInMinutes =  (Number( new Date(this.timeSlots[0].To)) - Number(new Date( this.timeSlots[0].From))) / 60000;
               this.slotDuration = diferentInMinutes
               if(this.slotDuration>60){
                let Duration = this.slotDuration-60
                this.calendarOptions.slotDuration = `01:${Duration}:00 `
              }
              else{this.calendarOptions.slotDuration = `00:${this.slotDuration}:00 `}

            }
            else{this.displayDefaultLegends = false;}
            this.isLoading = false
          },

        })
    }

  }
  onClearClick(){
    this.selectedCompany = { } as ResponseCompanies
    this. selectedLocation= undefined
    this.selectedDepartment = undefined
    this.selectedMake = undefined
    this.selectedService = undefined
    this.selectedResource = undefined
    this.timeSlots = []
    this.displayDefaultLegends = true;
  }
  onPlateNumberSearch(){
    this.onClearClick()
    this.schedulerEvents=[]
   this.defaultLegends= this.legendsWithEvent
   this.isLoading = true
   this.isSearchingSchedules = true;
   this.isSearchedByPlate= true

   this.appointments$= this.incadeaBookingService.getIBAppointment("0",this.plateNumber,"1","20").pipe(
    map((result) => {
      if (!result || !result.Appointment || result.Appointment.length === 0) {
          throw { status: 204 }; // Controled error to handle in catchError
      }
      return result;
    }),

    catchError((error): Observable<IBAppointmentGET> => {
      // Manejo de error 401
      if (error.status === 401) {
        this.helperService.logoutToken();
      }

      console.error('Error:', error);
      const translateText=this.translate.instant('NotfoundPlateMsg', {
        plateNumberSearch: this.plateNumber.toLocaleUpperCase()
      });
      this.helperService.showAlert =true
            this.helperService.typeAlert ="warning"
            this.helperService.messageAlert =translateText
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
              this.displayDefaultLegends = true;
       this.isLoading = false
       this.isSearchingSchedules = false;
       this.schedulerEvents[this.schedulerEvents.length] ={
        groupId: 'testGroupId',
        start: '2014-11-10T10:00:00',
        end: '2014-11-10T16:00:00',
        display: 'inverse-background'
      }
      return error;

    }),

    tap((result)=>{

        result.Appointment.forEach((appointment)=>{
          appointment.start= new Date(appointment.Start)
          appointment.end= new Date(appointment.End)
        })

    this.schedulerEvents=result.Appointment
    this.schedulerEvents.map((event) => {event.title =  event.MakeName
      })
      this.calendarOptions.initialDate=this.schedulerEvents[0].start
    //console.log('Result',this.schedulerEvents);
    const translateText = this.translate.instant('FindPlateMsg', {
      schedulerEventsLength: this.schedulerEvents.length,
      plateNumberSearch: this.plateNumber
    });

    this.schedulerEvents[this.schedulerEvents.length] ={
      groupId: 'testGroupId',
      start: '2014-11-10T10:00:00',
      end: '2014-11-10T16:00:00',
      display: 'inverse-background'
    }
    this.displayDefaultLegends = false;
      this.helperService.showAlert =true
      this.helperService.typeAlert ="success"
      this.helperService.messageAlert =translateText
      setTimeout(() => {
        this.helperService.showAlert =false
        }, 7000)
      this.isLoading = false
      this.isSearchingSchedules = false;

   })

   )


  }
  onClearPlate(){
    this.isSearchedByPlate= false
    this.displayDefaultLegends = true;
    this.plateNumber=''
    this.defaultLegends = this.legends
    this.schedulerEvents= [{
      groupId: 'testGroupId',
      start: '2014-11-10T10:00:00',
      end: '2014-11-10T16:00:00',
      display: 'inverse-background'
    }]

  }



  openDialog(event: any){

     if(!event.jsEvent.target.classList.contains('fc-bg-event') && !event.jsEvent.target.classList.contains('fc-non-business')){
if (this.selectedResource) {
  let originalTime = new Date(event.date);
  let newTime = new Date(originalTime.getTime() + this.slotDuration * 60000);
  event.start= event.date,
  event.end= newTime

  const dialogEventData : AppointmentPartial ={
    start : event.start,
    end: event.end,
    selectedLocation: this.selectedLocation!,
    selectedDepartment: this.selectedDepartment!,
    selectedMake: this.selectedMake!,
    selectedService: this.selectedService!,
    selectedResource:this.selectedResource!,
    selectedCompany:this.selectedCompany!,
    token:this.tokenString
  }
  const dialog=this.dialog.open(FindClientInfoDialog,{

        panelClass: "icon-outside",
        data: dialogEventData
      }).afterClosed().subscribe({
        next:()=> {
          if (this.selectedResource) {
            this.onResourceChange()
          }
        },
        complete: ()=>{
          dialog.unsubscribe()
        }

      })

}}
  }
  onAppointmentClick(appointment:any) {

    if(!appointment.jsEvent.target.classList.contains('fc-bg-event')){


     let dataAppointmet:any = {...appointment.event._def.extendedProps,
       hour:appointment.el.innerText.split('\n')[0],
       id:appointment.event._def. publicId,
       schedules:this.schedulerEvents,
       start: appointment.event._def.extendedProps.Start ,
       end:   appointment.event._def.extendedProps.End,token:this.tokenString
     }

     const dialogRef = this.dialog.open(IPopoverReschedulingComponent, {
       width: '471px',
       panelClass: 'icon-outside',
       data: dataAppointmet,
     });
     dialogRef.afterClosed().subscribe((result)=>{
      if (result) {
        this.isSearchingSchedules = true;
        this.appointments$= this.incadeaBookingService.getIBAppointment("0",this.plateNumber,"1","20").pipe(
          map((result) => {
            if (!result || !result.Appointment || result.Appointment.length === 0) {
                throw { status: 204 }; // Controled error to handle in catchError
            }
            return result;
          }),
          catchError((error): Observable<IBAppointmentGET> => {
            // Manejo de error 401
            if (error.status === 401) {
              this.helperService.logoutToken();
            }

            this.schedulerEvents=[]
            this.displayDefaultLegends = true;
            this.isSearchingSchedules =false;

            return error;

          }),
          tap((result)=>{

              result.Appointment.forEach((appointment)=>{
                appointment.start= new Date(appointment.Start)
                appointment.end= new Date(appointment.End)
              })
          this.schedulerEvents=result.Appointment
          this.schedulerEvents.map((event) => {event.title =  event.MakeName})
          this.calendarOptions.initialDate=this.schedulerEvents[0].start
          this.schedulerEvents[this.schedulerEvents.length] ={
            groupId: 'testGroupId',
            start: '2014-11-10T10:00:00',
            end: '2014-11-10T16:00:00',
            display: 'inverse-background'
          }
          this.isSearchingSchedules =false;
         })
         )
      }})
    }


}
}
